import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ManagerMenuService } from './manager-menu.service';
import { ManagerModel } from 'src/app/core/models/manager.model';

@Component({
  selector: 'app-manager-menu',
  templateUrl: './manager-menu.component.html',
  styleUrls: ['./manager-menu.component.scss']
})
export class ManagerMenuComponent implements OnInit {

  public menuItemList: ManagerModel[];
  public locationUrl: string;
  public showBackground: boolean;

  @ViewChild('navDropMobileButton', { static: true }) navDropMobileButton;
  @ViewChild('navDropMobile', { static: true }) navDropMobile;

  constructor(
    private managerMenuService: ManagerMenuService,
    private renderer2: Renderer2
  ) { }

  ngOnInit() {
    this.menuItemList = this.managerMenuService.getMenuList();
    this.locationUrl = window.location.pathname;
  }
  
  public setMenuActive(route?: string): void {
    this.locationUrl = route;
  }

  public hideMenu() {
    this.navDropMobileButton.nativeElement.click();
  }

  // public showBackgroundMenu(click?, menuItem?) {
  //   if(this.showBackground || menuItem) {
  //     click && !menuItem ? this.hideMenu() : null;
  //     this.renderer2.setStyle(this.navDropMobile.nativeElement, 'borderRadius', '0');
  //     this.showBackground = false;
  //   } else {
  //     this.renderer2.setStyle(this.navDropMobile.nativeElement, 'borderRadius', '0 0 28px 28px');
  //     this.showBackground = true;
  //   }
  // }
}
